import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a11bf1d")

_pushScopeId("data-v-5a11bf1d")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "text-primary",
  style: {"margin-top":"0"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Rate Trainer")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Trainer Classes")
const _hoisted_5 = { class: "video-info" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button, {
                        icon: "chevron-back",
                        text: "",
                        color: "medium",
                        "default-href": "classes"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { color: "medium" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.trainer.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, {
                  class: "border-bottom",
                  style: {"padding-bottom":"20px","margin-bottom":"10px"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      sizeLg: "6"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, {
                          class: "category-card trainer-image",
                          style: {
									background: 'url(' + _ctx.trainer.imgURL + ')',
								}
                        }, null, 8, ["style"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      sizeLg: "6"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card, {
                          class: "bio-card",
                          style: {"padding":"10px"}
                        }, {
                          default: _withId(() => [
                            (_ctx.isWeb)
                              ? (_openBlock(), _createBlock("h3", _hoisted_2, _toDisplayString(_ctx.trainer.name), 1))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_col, {
                              size: "6",
                              sizelg: "4",
                              "size-sm": "4"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.createStars(), (starIcon, index) => {
                                  return (_openBlock(), _createBlock(_component_ion_icon, {
                                    color: "primary",
                                    key: index,
                                    icon: starIcon
                                  }, null, 8, ["icon"]))
                                }), 128)),
                                _createVNode(_component_ion_button, {
                                  style: [{"margin-bottom":"25px"}, [
											_ctx.trainer?.mirror && !_ctx.isWeb
												? { width: '80% !important' }
												: {},
										]],
                                  color: _ctx.getColor(),
                                  size: _ctx.trainer?.mirror && !_ctx.isWeb ? 'small' : 'block',
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateTrainerRating()))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }, 8, ["color", "size", "style"])
                              ]),
                              _: 1
                            }),
                            _createVNode("span", {
                              style: {"line-height":"1.5em"},
                              innerHTML: _ctx.trainer.bio
                            }, null, 8, ["innerHTML"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trainerVids, (classObject, index) => {
                      return (_openBlock(), _createBlock(_component_ion_col, {
                        size: "12",
                        "size-lg": "4",
                        "size-md": "4",
                        "size-sm": "12",
                        key: index
                      }, {
                        default: _withId(() => [
                          (_ctx.isBookmarked(classObject))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                class: "bookmarkBtn",
                                fill: "clear",
                                onClick: ($event: any) => (_ctx.removeBookmark(classObject))
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.bookmark,
                                    color: "light"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_ion_button, {
                                key: 1,
                                class: "bookmarkBtn",
                                fill: "clear",
                                onClick: ($event: any) => (_ctx.addBookmark(classObject))
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    color: "light",
                                    icon: _ctx.bookmarkOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])),
                          _createVNode(_component_ion_card, {
                            button: "",
                            onClick: ($event: any) => (_ctx.openModal(classObject)),
                            class: "category-card"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_badge, {
                                color: "primary",
                                class: "class-badge"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(classObject.isLive ? "LIVE" : "On Demand"), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_img, {
                                src: classObject?.imgURL
                              }, null, 8, ["src"]),
                              _createVNode("div", _hoisted_5, [
                                _createVNode("b", null, _toDisplayString(classObject?.duration) + " Minute " + _toDisplayString(classObject?.name), 1),
                                _hoisted_6,
                                _createVNode("span", _hoisted_7, _toDisplayString(classObject.trainerData.name) + " | " + _toDisplayString(classObject?.categoryName), 1),
                                (_ctx.hasProgressed(classObject))
                                  ? (_openBlock(), _createBlock(_component_ion_badge, {
                                      key: 0,
                                      color: "dark",
                                      class: "class-watched"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(_ctx.progressType(classObject.classID)), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      (!_ctx.isWeb)
        ? (_openBlock(), _createBlock(_component_bottombar, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})